import URI from "urijs";
import getUrl from "./getUrl";
import ITabMenuContentItem from "../models/ITabMenuContentItem";

export const normalizeUri = (uri: string): string => {
  const parsed = URI(uri);
  return parsed
    .normalize()
    .toString()
    .toLowerCase();
};

const normalizeUris = (uris: string[]): string[] => {
  const result = [];
  for (let i = 0; i < uris.length; i++) {
    result.push(normalizeUri(getUrl(uris[i])));
  }
  return result;
};

export const normalizeItemUris = (item: ITabMenuContentItem): ITabMenuContentItem => {
  return {
    name: item.name,
    type: item.type,
    href: item.href ? normalizeUri(getUrl(item.href)) : undefined,
    exactMatches: item.exactMatches ? normalizeUris(item.exactMatches) : undefined,
    startMatches: item.startMatches ? normalizeUris(item.startMatches) : undefined,
    docSection: item.docSection,
  };
};
